import moment from 'moment';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import { Cell, Row } from 'layout/atoms/TableGrid';
import { openModal, openSidebar } from 'store/layoutSlice';
import Button from '../Button/Button';
import Dropdown from '../Dropdown/Dropdown';
import ExpandableLinkList from '../ExpandableLinkList';
import StatusBadge from '../StatusBadge';
import styles from './WarehouseReleasesListItem.module.scss';
function WarehouseReleasesListItem({ warehouseRelease }) {
    var _a, _b;
    const { t } = useTranslation(['common', 'warehouseReleases']);
    const location = useLocation();
    const dispatch = useDispatch();
    const STATUS_COLORS = {
        DRAFT: 'neutral',
        APPROVED: 'info',
        CANCELLED: 'negative',
        DONE: 'positive',
    };
    const handleSpecPreviewOpen = (id) => {
        dispatch(openSidebar({ name: 'specificationPreview', id }));
    };
    const handleRemove = useCallback(() => {
        dispatch(openModal({
            name: 'removeWarehouseRelease',
            data: { id: warehouseRelease.id, releaseId: warehouseRelease.releaseId },
        }));
    }, [dispatch, warehouseRelease.id, warehouseRelease.releaseId]);
    return (React.createElement(Row, null,
        React.createElement(Cell, { align: "left" },
            React.createElement(Link, { to: `${location.pathname}/${warehouseRelease.id}`, className: styles.link }, warehouseRelease.releaseId)),
        React.createElement(Cell, { align: "left" },
            React.createElement(ExpandableLinkList, { links: [
                    {
                        id: ((_a = warehouseRelease.warehouseReleaseModel) === null || _a === void 0 ? void 0 : _a.modelSpecification.id) || '',
                        label: ((_b = warehouseRelease.warehouseReleaseModel) === null || _b === void 0 ? void 0 : _b.modelSpecification.itemCode) || '',
                        onClick: () => {
                            var _a;
                            return handleSpecPreviewOpen((_a = warehouseRelease.warehouseReleaseModel) === null || _a === void 0 ? void 0 : _a.modelSpecification.id);
                        },
                    },
                ] })),
        React.createElement(Cell, { align: "left" }, warehouseRelease.sumOfModelQuantities),
        React.createElement(Cell, { align: "left" }, warehouseRelease.receiver),
        React.createElement(Cell, { align: "left" },
            React.createElement(StatusBadge, { noIcon: true, size: "s", theme: "fill", color: STATUS_COLORS[warehouseRelease.status] }, t(`warehouseReleases:status.${warehouseRelease.status}`))),
        React.createElement(Cell, { align: "left" }, moment(warehouseRelease.createdDate).format('DD.MM.YYYY')),
        React.createElement(Cell, { align: "left" }, moment(warehouseRelease.modifiedDate).format('DD.MM.YYYY')),
        React.createElement(Cell, null,
            React.createElement(Dropdown, null,
                React.createElement(Button, { align: "left", theme: "ghost", color: "danger", leftIcon: React.createElement(TrashSvg, null), onClick: handleRemove, disabled: warehouseRelease.status !== 'DRAFT' }, t('delete'))))));
}
export default WarehouseReleasesListItem;
